import {config, request, objectSerial} from 'Utils';

// 开单管控_产品种类
export function categoryBig() {
    return request(`${config.server}/api/v1/dmsOrderManage/categoryTree`, {
        method: 'get'
    });
}

//获取产品树
export function treeList2(param) {
    return request(`${config.server}/api/v1/dms/category/listTree?id=${param}`);
}

// 列表
export function fetchList(param) {
    return request(`${config.server}/api/v1/dmsOrderManage/list`, {
        method: 'post',
        body: param
    });
}

// 编辑或新建
export function saveOrUpdate(param) {
    return request(`${config.server}/api/v1/dmsOrderManage/save`, {
        method: 'post',
        body: param
    });
}

export function Update(param) {
    return request(`${config.server}/api/v1/dmsOrderManage/update`, {
        method: 'post',
        body: param
    });
}

// 详情
export function detail(param) {
    return request(`${config.server}/api/v1/dmsOrderManage/detail/${param.id}`, {
        method: 'get'
    });
}

// 查询区域
export function fetchArea() {
    return request(`${config.server}/api/v1/dmsOrderManage/area`, {
        method: 'get'
    });
}

// 查询生产线
export function fetchLine() {
    return request(`${config.server}/api/v1/dmsOrderManage/productLine`, {
        method: 'get'
    });
}

// 根据区域查询地区
export function fetchCity(param) {
    return request(`${config.server}/api/v1/dmsOrderManage/region/${param.id}`, {
        method: 'get'
    });
}

// 查询所有渠道
export function fetchChannels() {
    return request(`${config.server}/api/v1/dmsOrderManage/channel`, {
        method: 'get'
    });
}

// 查询所有客户
export function fetchCustomer() {
    return request(`${config.server}/api/v1/dmsOrderManage/customer`, {
        method: 'get'
    });
}

// 查询所有细分产品线
export function fetchSubdivideProLine() {
    return request(`${config.server}/api/v1/dmsOrderManage/subdivideProLine`, {
        method: 'get'
    });
}

// 禁用配置
export function disableCtrl(param) {
    return request(`${config.server}/api/v1/dmsOrderManage/update?${objectSerial(param)}`);


}

// 启用配置
export function enableCtrl(param) {
    return request(`${config.server}/api/v1/dms/billingCtrl/valid?${objectSerial(param)}`);
}


// 客户专属物料列表
export function fetchList2(param) {
    return request(`${config.server}/api/v1/dmsOrderManage/list2`, {
        method: 'post',
        body: param
    });
}

// 客户专属物料列表更新
export function Update2(param) {
    return request(`${config.server}/api/v1/dmsOrderManage/update2`, {
        method: 'post',
        body: param
    });
}

// 客户名称列表查询
export function getCusName() {
    return request(`${config.server}/api/v1/dmsOrderManage/getCusName`, {
        method: 'post'
    });
}

// 物料列表查询
export function getItem(param) {
    return request(`${config.server}/api/v1/dmsOrderManage/getItem`, {
        method: 'post',
        body: param
    });
}

// 保存
export function add(param) {
    return request(`${config.server}/api/v1/dmsOrderManage/add`, {
        method: 'post',
        body: {...param}
    });
}



// WEBPACK FOOTER //
// ./src/service/billingCtrl/index.js